export const EVENT_TYPE_CALL: string = 'call';
export const EVENT_TYPE_EMAIL: string = 'email';
export const EVENT_TYPE_CHAT: string = 'chat';
export const EVENT_TYPE_FEEDBACK: string = 'feedback';

export const ALL_EVENT_TYPES: readonly string[] = [
    EVENT_TYPE_CALL,
    EVENT_TYPE_EMAIL,
    EVENT_TYPE_CHAT,
    EVENT_TYPE_FEEDBACK,
] as const; 